import React from "react";
import Typography from "@mui/material/Typography";

import { useNetworkImportType } from "./useNetworkImportType";

import { EditWrapper } from "../EditWrapper";

const IMPORT_TYPES = [
  "OPEN",
  "PASSCODE",
  "CBORD",
  "RMS",
  "RMBG",
  "ENTRATA",
  "ACC",
  "Kinetic"
];

interface IProps {
  isPreview?: boolean;
}

export const NetworkImportType: React.FC<IProps> = (props) => {
  const { importType, handleImportTypeChange } = useNetworkImportType();

  return (
    <>
      {props.isPreview && (
        <Typography variant="subtitle1">
          Import type: {importType || "unspecified"}
        </Typography>
      )}
      {!props.isPreview && (
        <EditWrapper
          options={IMPORT_TYPES}
          defaultValue={importType}
          onEditSuccess={handleImportTypeChange}
        >
          <Typography variant="subtitle1">
            Import type: {importType || "unspecified"}
          </Typography>
        </EditWrapper>
      )}
    </>
  );
};
